<template>
  <LaybyCard :order="order" />
</template>

<script setup lang="ts">
import LaybyCard from '@/components/shopper/lay-by/LaybyCard.vue';
import type { ModelOrderResponse } from '@layup/api-sdk';

defineProps<{ order?: ModelOrderResponse }>();
</script>
